import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/hooks/useRedux';
import { DashboardShellSkeleton } from './UI/Skeleton';

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <DashboardShellSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/vendor-signin" replace state={{ from: location }} />;
  }

  return children;
};

export default AuthWrapper;
